export const usePartnerStore = defineStore('partner', () => {
  const partnerInfo = ref<Partner | null>(null)
  const partnersKey = ref<string | null>(null)

  const setPartner = (info: Partner) => {
    partnerInfo.value = info
  }

  const setPartnersKey = (param: string) => {
    partnersKey.value = param
  }

  const clear = () => {
    partnerInfo.value = null
    partnersKey.value = null
  }

  return {
    partnerInfo,
    partnersKey,
    setPartner,
    setPartnersKey,
    clear
  }
})
